// import Section from "emun.catalogs/sections/section.model";
const dates = ["createdOn", "publishOn", "expiresOn"];
import $appConfig from "servicestack/config";

export default class Catalog {
  constructor(dto = {}, getProducts = false) {
    Object.assign(this, dto);
    // this.sections = dto.sections.map(l => new Section(l));
    // if (getProducts) {
    //   const map = keyBy(dto.sections, "productId"); //groupBy
    //   ServiceBus.read(
    //     `QueryProducts.json?RetailerId=${dto.retailerId}&IdIn=${Object.keys(
    //       map
    //     ).join(",") || "NONE"}`
    //   ).then(({ data }) => {
    //     const productMap = keyBy(data.results, "id"); //groupBy
    //     for (const l of this.sections) {
    //       Object.assign(l.product || {}, productMap[l.productId] || {});
    //     }
    //   });
    // }
    for (const f of dates) {
      if (dto[f]) {
        this[f] = new Date(dto[f]);
      }
    }
  }

  img(size = "small") {
    return this.imgs(size)[0];
  }

  imgs(size = "small") {
    return [
      $appConfig.catalogImg(
        "catalog",
        this.id,
        size,
        "jpg",
        `m=${encodeURIComponent(this.modifiedOn)}`
      ),
      $appConfig.altCatalogImg(
        "catalog",
        this.id,
        size,
        "jpg",
        `m=${encodeURIComponent(this.modifiedOn)}`
      ),
    ];
  }
}
